import React, { PropTypes } from 'react'
import { PageHead } from './PageHead'

const BarePage = ({ children, title, noPageHead }) => (
  <div>
    {!noPageHead && <PageHead title={title} />}
    <main id='main-content'>
      {children}
    </main>
  </div>
)

BarePage.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  noPageHead: PropTypes.bool,
  showFooter: PropTypes.bool
}

export default BarePage
